import FieldConfig from "../../../proto/field-config"
import FieldNumber from "../../../generic/number/number"
import ItemModelV2 from "../../../../model2/item2/item-model"
import TasksViewManager from "../../../../gd-modules/tasks-view/core/manager"
import {LifecycleAction} from "../../../../gd/const/lifecycle"
import Project from "../../../../model2/project/project"
import {ViewType} from "../../../../gd/const/views/view-type"
import GanttManager from "../../../../gd-modules/gantt-chart/manager/manager"
import FieldProto_updateView from "../../../proto/render/table/function/update-view"

export default class FieldProjectDurationWorkdays extends FieldNumber {

    constructor(config:FieldConfig) {
        super(config);

        this.icon               = 'i5-age'
        this.label              = 'Duration work days'

        this.fieldParams.tableCellOnValueChange = this.tableCellOnValueChange
    }

    canEdit(model:Project):boolean {
        return model.acl.canChangeDuration
    }

    tableCellOnValueChange = async (item: ItemModelV2, value: number, manager: TasksViewManager|GanttManager) => {
        switch (manager.module) {
            case ViewType.PROJECT_GANTT:
            case ViewType.PORTFOLIO_GANTT:
            case ViewType.CUSTOM_VIEW_GANTT:
                const ganttManager = manager as GanttManager
                ganttManager.updateFieldManager2.setWorkDuration(item.id, value)
                break

            default:
                item.project.durationWorkdays = value
                item.project.save()

                item.updateLastUpdateTime() // otherwise it wont re-render

                FieldProto_updateView(manager as TasksViewManager, this)
                break
        }
    }

}
